import { onError } from "@apollo/client/link/error";
import * as Auth from "../../utils/Auth";

const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors) {
    graphQLErrors.map(({ message, locations, path }) => {
      console.log(
        `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
      );
      if (
        message === "Authentication Required." ||
        message === "Authorization Required."
      ) {
        console.log(graphQLErrors);
        console.error('Must login');
        Auth.logout();
      }
    });
  }
  if (networkError) console.log(`[Network error]: ${networkError}`);
});

export default errorLink;
